import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_mst_label_exts_RowClass, bl_inv_mst_label_hdr_RowClass } from '../../../dbschema';

export class InventoryLabelContainerModel extends BaseContainerModel {
  bl_inv_mst_label_hdr: bl_inv_mst_label_hdr_RowClass = new bl_inv_mst_label_hdr_RowClass();
  bl_inv_mst_label_exts: bl_inv_mst_label_exts_RowClass[] = [];
}

